import {MARKETING_BASENAME} from '../marketing/marketingBase'

/** Paths from commercial-stk App.tsx (marketing site), allowed without a session */
// Exact-match landing page routes that are publicly accessible.
const MARKETING_EXACT = new Set([
  '/how-it-works',
  '/about',
  '/integrations',
  '/updates',
  '/careers',
  '/blog',
  '/contact',
  '/help-center',
  '/docs',
  '/api-reference',
  '/status',
])

export function isMarketingPath(pathname) {
  if (pathname === MARKETING_BASENAME || pathname.startsWith(`${MARKETING_BASENAME}/`)) return true
  if (pathname === '/features' || pathname.startsWith('/features/')) return true
  if (MARKETING_EXACT.has(pathname)) return true
  return false
}

// In app routes beyond landing page that are publicly accessible without auth.
const BASE_PUBLIC = new Set([
  '/',
  '/login',
  '/store',
  '/store/create',
  '/store/onboard',
  '/404',
  '/undefined',
  '/track-time',
  '/group/create',
  '/register',
  '/archived',
  '/support/console',
  '/signup',
])

const EMPLOYEE_PATH_REGEX = /^\/[a-f\d]{24}\/(register|onboard)$/

/**
 * @param {string} pathname
 * @param {string | undefined} paramsStore - useParams().store for :store/register
 */
export function isPublicPath(pathname, paramsStore) {
  if (isMarketingPath(pathname)) return true
  if (BASE_PUBLIC.has(pathname)) return true

  const isEmployeePublicPath =
    paramsStore && (pathname === `/${paramsStore}/register` || pathname === `/${paramsStore}/onboard`)

  const isEmployeePathByRegex = EMPLOYEE_PATH_REGEX.test(pathname)

  return Boolean(isEmployeePublicPath || isEmployeePathByRegex)
}

export function isEmployeeInvitePath(pathname) {
  return EMPLOYEE_PATH_REGEX.test(pathname)
}
